import { AlertTriangle } from "lucide-react";
import { useLocale } from "../../../context/LanguageContext";

interface PublishEventDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  eventName: string;
}

export function PublishEventDialog({
  isOpen,
  onClose,
  onConfirm,
  loading,
  eventName,
}: PublishEventDialogProps) {
  if (!isOpen) return null;

  const { t } = useLocale();

  return (
    <>
      <div
        className="fixed inset-0 z-50 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-lg border border-border bg-card p-6 shadow-xl">
          <div className="mb-4 flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                {t("shared.publishEvent.title")}
              </h3>
              <p className="mt-1 text-sm text-muted-foreground">
                {t("shared.publishEvent.message", { name: eventName })}
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="inline-flex h-9 items-center rounded-md border border-border px-4 text-sm font-medium text-foreground hover:bg-muted disabled:opacity-50"
            >
              {t("common.cancel")}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              className="inline-flex h-9 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
            >
              {loading ? t("shared.publishEvent.publishing") : t("common.confirm")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
